<div class="div-action-top">
  <form nz-form [nzLayout]="'inline'" [formGroup]="filterForm" class="form-filter" (ngSubmit)="doSearch()">
    <nz-form-item class="spacepad">
      <nz-form-control>
        <nz-date-picker formControlName="fromDate" nzPlaceHolder="Từ ngày..." nzFormat="dd/MM/yyyy" nz-input
                        placeholder="Từ  ngày">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="spacepad">
      <nz-form-control>
        <nz-date-picker formControlName="toDate" nzPlaceHolder="Đến ngày..." nzFormat="dd/MM/yyyy" nz-input
                        placeholder="Đến ngày">
        </nz-date-picker>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="spacepad">
      <nz-form-control>
        <button nzSize="default" nz-button nzType="primary" type="submit" [disabled]="!filterForm.valid">Tìm kiếm</button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="spacepad">
      <nz-form-control>
        <button nzSize="default" nz-button nzType="primary" type="button" (click)="showModalAdd()" *ngIf="checkAdd">
          <em class="fas fa-plus fa-fw"></em> Tạo lượt kiểm kê
        </button>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
<div class="data-table">
  <nz-table #basicTable [nzData]="datas" (nzCurrentPageDataChange)="currentPageDataChange($event)"
            [nzPageSizeOptions]="pageSize"
            [nzTotal]="total"
            [nzFrontPagination]="false"
            [nzPageSize]="defaultPage" nzSize="small" nzShowSizeChanger
            [nzShowTotal]="rangeTemplate" [nzLoading]="loading">
    <thead>
    <tr>
      <th nzShowCheckbox nzLeft="0px" nzWidth="50px" [(nzChecked)]="isAllDisplayDataChecked"
          [nzIndeterminate]="isIndeterminate" (nzCheckedChange)="checkAllRow($event)"></th>
      <th class="text-nowrap" width="50px">#</th>
      <th class="text-nowrap">Lý do kiểm kê</th>
      <th class="text-nowrap">Bắt đầu</th>
      <th class="text-nowrap">Kết thúc</th>
      <th class="text-nowrap">Trạng thái</th>
      <th class="text-nowrap">Người tạo</th>
      <th class="text-nowrap">Kết quả kiểm kê</th>
      <th class="text-nowrap">Đã xử lý phần chênh</th>
      <th class="text-nowrap">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of basicTable.data;let i = index;" [class]="toWarningClass(data)">
      <td nzShowCheckbox [(nzChecked)]="mapOfCheckedId[data.id]" (nzCheckedChange)="refreshStatus()" nzLeft="0px"
          nzWidth="50px"></td>
      <td class="text-nowrap">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td class="text-nowrap">{{ data.reason }}</td>
      <td class="text-nowrap">{{ data.dateCreated | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ data.dateFinished | date:'dd/MM/yyyy HH:mm' }}</td>
      <td class="text-nowrap">{{ toStatusText(data.inventoryStatus) }}</td>
      <td class="text-nowrap">{{ data.user.fullname }}</td>
      <td class="text-nowrap ">{{ toResult(data) }}</td>
      <td class="text-nowrap ">
        <label [nzDisabled]="true" nz-checkbox [nzChecked]="data.isProcessed"></label>
        <span *ngIf="data.isProcessed">{{data.warehouseExportCode}}</span>
      </td>
      <td class="text-nowrap">
        <!--<button nz-button nzType="danger" nzSize="small" class="btn-right" (click)="showConfirm(data.id)"
                *ngIf="checkDelete"><span class="fa fa-times fa-fw"></span>
        </button>-->
        <button title="Bắt đầu kiểm kê" nz-button nzType="default" nzSize="small" class="btn-right"
                (click)="startInventory(data)"
                *ngIf="data.inventoryStatus === 0"><span class="fa fa-play fa-fw"></span>
        </button>
        <button title="Tiến hành quét barcode" nz-button nzType="default" nzSize="small" class="btn-right"
                (click)="popupInventory(data)"
                *ngIf="data.inventoryStatus === 1"><span class="fa fa-barcode fa-fw"></span>
        </button>
        <button title="Hoàn thành kiểm kê" nz-button nzType="default" nzSize="small" class="btn-right"
                (click)="confirmComplete(data)"
                *ngIf="data.inventoryStatus === 1"><span class="fa fa-stop-circle fa-fw"></span>
        </button>
        <button nz-button nzType="default" nzSize="small" class="btn-right" (click)="showDetails(data)"
                *ngIf="data.inventoryStatus >= 1"><span class="fa fa-info fa-fw"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range" let-total>
    {{ range[0] }}-{{ range[1] }} {{'of' | translate }} {{ total }} {{'items' | translate }}
  </ng-template>
</div>


<nz-modal [nzWidth]="600" [(nzVisible)]="isVisibleAdd" nzClosable="false" [nzTitle]="title1" nzMaskClosable="false">
  <ng-template #title1>
    Thông tin lượt kiểm kê
    <div class="pull-right icon-close">
      <em (click)="handleCancel()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="loadingButton">
    <div *ngIf="enableEdit">
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="8">Lý do<em
          class="fa fa-asterisk required"></em></label>
        <div nz-col [nzSpan]="16">
          <input nz-input placeholder="" [(ngModel)]="item.reason"/>
        </div>
      </div>
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="8">Danh mục vật tư<em
          class="fa fa-asterisk required"></em></label>
        <div nz-col [nzSpan]="16">
          <nz-tree-select
            style="width: 100%"
            [(ngModel)]="listChemicalId"
            [nzNodes]="treeChemicals"
            (ngModelChange)="chemicalsChange($event)"
            nzShowSearch
            nzCheckable
            nzPlaceHolder=""
          ></nz-tree-select>
        </div>
      </div>
      <div class="input-wrap nz-row row-width">
        <label class="title-detail text-text" nz-col [nzSpan]="8">Người thực hiện<em class="fa fa-asterisk required"></em></label>
        <div nz-col [nzSpan]="16">
          <nz-select nzAllowClear nzMode="multiple" nzShowSearch nzPlaceHolder="Chọn người thực hiện"
                     style="width: 100%"
                     [(ngModel)]="listUserId">
            <nz-option *ngFor="let cat of inputUsers" [nzValue]="cat.id" [nzLabel]="cat.fullname"></nz-option>
          </nz-select>
        </div>
      </div>
    </div>
    <div *nzModalFooter>
      <button nz-button (click)="handleCancel()">{{'cancel' | translate }}</button>
      <button nz-button nzType="primary" (click)="handleOk()" class="button-submit">{{'save' | translate }}</button>
    </div>
  </nz-spin>
</nz-modal>

<!-- Hiển thị chi tiết -->
<nz-modal *ngIf="item" nzClassName="view-modal" class=" ant-select-disabled ant-select-arrow" nzWidth="900px"
          [(nzVisible)]="isVisibleViewDetail" nzClosable="false" [nzTitle]="title" nzMaskClosable="false">
  <ng-template #title>
    Kết quả kiểm kê chi tiết
    <div class="pull-right icon-close">
      <em (click)="handleCancelView()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Lượt kiểm kê:</div>
    <div>{{item.reason}}</div>
  </div>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Bắt đầu:</div>
    <div>{{ item.dateCreated | date:'dd/MM/yyyy HH:mm' }}</div>
  </div>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Kết thúc:</div>
    <div>{{ item.dateFinished | date:'dd/MM/yyyy HH:mm' }}</div>
  </div>
  <button [disabled]="dataView.isProcessed" nz-button nzType="primary" (click)="fixShortage()" class="button-submit">
    <span class="fa fa-fw fa-edit"></span>
    Xử lý phần chênh</button>
  <nz-table #spreadsheet class="table" id="detailTable2" [nzData]="warehouseInventoryResults">
    <thead>
    <tr>
      <th class="text-center" nzWidth="60px">STT</th>
      <th class="width-large" nzWidth="280px">Hóa chất</th>
      <th class="width-small text-center" nzWidth="100px">Tổng số</th>
      <th class="width-large text-center" nzWidth="120px">Thiếu</th>
      <th class="width-small text-center" nzWidth="120px">Thừa</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of spreadsheet.data;let i = index;"
        [class]="(data.totalShortage !== 0 || data.totalRedundancy !== 0) ? 'warning' : ''">
      <td class="text-center">{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td>
        {{ data.chemical | packingFormat }}
      </td>
      <td class="text-center">
        <div>
          {{ data.totalInventory }}
        </div>
      </td>
      <td class="text-center">
        {{ data.totalShortage }}
      </td>
      <td class="text-center">
        <div>
          {{ data.totalRedundancy}}
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div *nzModalFooter>
    <button nz-button (click)="handleCancelView()">{{'cancel' | translate }}</button>
  </div>
</nz-modal>

<nz-modal *ngIf="item" nzClassName="view-modal" class=" ant-select-disabled ant-select-arrow" nzWidth="900px"
          [(nzVisible)]="isVisibleViewScan" nzClosable="false" [nzTitle]="title" nzMaskClosable="false">
  <ng-template #title>
    Thông tin lượt kiểm kê
    <div class="pull-right icon-close">
      <em (click)="handleCancelScanDetail()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Lượt kiểm kê:</div>
    <div>{{item.reason}}</div>
  </div>
  <div class="input-wrap nz-row row-width">
    <div class="title-detail text-text" nz-col [nzSpan]="7">Bắt đầu:</div>
    <div>{{ item.dateCreated | date:'dd/MM/yyyy HH:mm' }}</div>
  </div>
  <nz-alert style="margin-bottom: 10px;" *ngIf="item" nzType="info"
            nzMessage="Số lượng đã kiểm kê {{item.totalInventoryed}}/{{item.totalInventory}}" nzShowIcon></nz-alert>

  <nz-table #spreadsheet class="table" id="detailTable" [nzData]="warehouseInventoryResults">
    <thead>
    <tr>
      <th nzWidth="80px">STT</th>
      <th class="width-large" nzWidth="280px">Hóa chất</th>
      <th class="width-small" nzWidth="100px">Barcode</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of spreadsheet.data;let i = index;"
        [class]="!data.inventoryed ? 'warning' : ''">
      <td>{{getRowIndex(i, basicTable.nzPageIndex, basicTable.nzPageSize)}}</td>
      <td>
        {{ data.chemical | packingFormat }}
      </td>
      <td>
        <div>
          {{ data.barCode }}
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div *nzModalFooter>
    <button nz-button (click)="handleCancelScanDetail()">{{'cancel' | translate }}</button>
  </div>
</nz-modal>

<nz-modal *ngIf="item" nzClassName="view-modal" class=" ant-select-disabled ant-select-arrow" nzWidth="400px"
          [(nzVisible)]="isVisibleScan" nzClosable="false" [nzTitle]="title" nzMaskClosable="false">
  <ng-template #title>
    Lượt kiểm kê: {{item.reason}}
    <div class="pull-right icon-close">
      <em (click)="handleCancelScan()" nz-icon nzType="close" nzTheme="outline"></em>
    </div>
  </ng-template>
  <div class="nz-row row-width">
    <div style="margin-bottom: 10px" class="div-scan">
      <span class="fa fa-fw fa-barcode"></span>
      <input [(ngModel)]="item.barcode" nz-input placeholder="Quét mã vạch ở đây" (ngModelChange)="doScan()"/>
    </div>
    <nz-alert style="margin-bottom: 10px;" *ngIf="successCount > 0" nzType="info"
              nzMessage="Số lượng đã kiểm kê {{successCount ? successCount : 0}}/{{totalInventory}}" nzShowIcon></nz-alert>
    <div *ngIf="resultItem" class="ul-chemical-info">
      <h3>Thông tin hóa chất</h3>
      <div>
        <ul *ngIf="resultItem.chemical">
          <li>
            <label>Hóa chất:</label> <strong>{{resultItem.chemical.name}}</strong>
          </li>
          <li>
            <label>Số lô:</label> {{resultItem.batchNumber}}
          </li>
          <li>
            <label>HSD:</label> {{resultItem.expiredDate | date: 'dd/MM/yyyy'}}
          </li>
          <li>
            <label>Seri:</label> {{resultItem.serialNumber}}
          </li>
          <li>
            <label>Quy cách đóng gói:</label> <span>{{resultItem.packingType}}</span>
          </li>
          <li>
            <label>Đơn vị tính: </label>
            <span>{{resultItem.unitTypeText}}</span>
          </li>
          <!-- <li>
            <label>Số lượng:</label>
            <span> {{resultItem.chemicalPackingQuantity}}</span>
          </li> -->
        </ul>
      </div>
      <nz-alert *ngIf="resultItem.isValid" nzType="success" nzMessage="Trùng khớp với tồn kho" nzShowIcon></nz-alert>
      <nz-alert *ngIf="!resultItem.isValid" nzType="error" nzMessage="{{resultItem.errorMessage}}"
                nzShowIcon></nz-alert>
      <div>
        <button nz-button nzType="dashed" style="margin: 10px auto;display: block;" *ngIf="resultItem.chemical"
                (click)="showLog(resultItem)">
          Xem chi tiết nhập/xuất
        </button>
        <ul>
          <li *ngFor="let item of logs">
            <strong>{{item.userName}}</strong> {{item.action}} {{item.recipient}} lúc: <strong>{{item.dateLog | date: 'dd/MM/yy HH:mm'}}</strong>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <br/>
  <div *nzModalFooter>
    <button *ngIf="successCount === totalInventory && successCount > 0" nz-button nzType="primary" (click)="completeInventory(item)">Hoàn thành kiểm kê</button>
    <button nz-button (click)="handleCancelScan()">Đóng</button>
  </div>
</nz-modal>
